import ModalBase from './ModalBase.Container';

export { default as ModalBaseChildrenWrapper } from './ModalBaseChildrenWrapper';
export default ModalBase;
